import { useRef, useState, useEffect } from 'react';
import TextBoxControl from "../../../Controls/TextBoxControl"
import ButtonControl from "../../../Controls/ButtonControl"
import GridControl from "../../../Controls/GridControl"

import { 
	GetLocal,
	FetchService
} from "../../../Base/BaseControl";

export default function Index(props) {
	
	const [getServiceResult, setServiceResult] = useState(false);

    useEffect(() => {

    }, []);

	const ShowLastConstruction =()=>{
        var inputValue = {
            session: GetLocal('OwnersSession')
        };
        FetchService("Owner/Urbanization/Request/ShowLastConstruction", inputValue, ShowLastConstructionSuccess);		
	}

	const ShowLastConstructionSuccess =(ServiceResult)=>{
		setServiceResult(ServiceResult);
	}		
	
	const onClicks =()=>{
		ShowLastConstruction();
	}	

    return (
        <div class="text-center">	
			{getServiceResult == false && 
				<ButtonControl 
					variant="btn btn-primary w-25"
					title="چاپ پروانه"
					icon="fa fa-print"
					onClick={onClicks}
				/>
			}
			
			{getServiceResult != false && <iframe src={"data:application/pdf;base64,"+getServiceResult} width="100%" height="600"></iframe> }
        </div>
    );
}
